module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Fc-Ge-Hc-Ib-Jb.97b7296c.png";